export const PRIMARY_FONT = "'Source Sans Pro', sans-serif;";
